import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/images/logo-left.png'
import _imports_1 from '../assets/images/centerLogo.png'
import _imports_2 from '../assets/images/logo-right.png'


const _hoisted_1 = {
  key: 0,
  class: "modalOuter"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modalInner" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modalHeader\"><div class=\"leftLogo\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"centerLogo\"><img src=\"" + _imports_1 + "\" alt=\"\"></div><div class=\"rightLogo\"><img src=\"" + _imports_2 + "\" alt=\"\"></div></div>", 1)
const _hoisted_5 = { class: "modalContent with-bg" }
const _hoisted_6 = { class: "modalContentInner" }
const _hoisted_7 = {
  cellpadding: "0",
  cellspacing: "0",
  border: "0"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { width: "50" }),
    /*#__PURE__*/_createElementVNode("td", null, "NAME"),
    /*#__PURE__*/_createElementVNode("td", null, "SCORE")
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modalFooter" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/",
    class: "btn btn-large btn-primary"
  }, "PLAY AGAIN")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaderboard, (entry, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: entry.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, _toDisplayString(entry.playerName), 1),
                        _createElementVNode("td", null, _toDisplayString(entry.score), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _hoisted_9
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}